import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityLayerService {

  // used due to Guard being separated as Login Manager
  private loginObj;

  constructor(private _snackBar: MatSnackBar,private authService: AuthService) { }

  tryLogin(loginObj){
    this.loginObj = loginObj;
    this.authService.tryLogin(loginObj);
  }

  isLoginManagerLoading(){
    return this.authService.getLoading();
  }

  setIsLoading(value){
    return this.authService.setIsLoading(value);
  }

  getCookie(cookie){
    return this.authService.getCookie(cookie);
  }

  logout(){
    this.authService.closeSession();
  }

  registerCloseSession(){
    /* this.loginManager.closeSession(); */
  }

  clearCache(){
    /* this.loginManager.clearCache(); */
  }

  delete_cookie(name) {
    /* this.loginManager.delete_cookie(name); */
  }

  getSecurityLayerObj(){
    return this.loginObj;
  }

  saveLoginObj(obj){
    this.loginObj = obj;
  }

  openSimpleSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  checkForCookies(path){
    return this.authService.checkForCookies(path);
  }

  checkToken(loginObj){
    this.loginObj = loginObj;
    return this.authService.validateLinkToken(loginObj);
  }

  saveNewPass(loginObj){
    this.loginObj = loginObj;
    this.authService.saveNewPass(loginObj);
  }

  updatePassword(loginObj){
    this.loginObj = loginObj;
    this.authService.updatePassword(loginObj);
  }
  
  generateNewLink(loginObj){
    this.loginObj = loginObj;
    this.authService.generateNewLink(loginObj);
  }

  
}